// extracted by mini-css-extract-plugin
export var CardContainer = "Card-module--CardContainer--2RKWi";
export var Title = "Card-module--Title--3P9_E";
export var Copy = "Card-module--Copy--t5i0P";